(function (root, factory) {
  'use strict';
  var gifts = factory();
  if (typeof module === 'object' && module.exports) module.exports = gifts;
  else if (root) root.WTXFirstOrderGifts = gifts;
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  function identifier(value) {
    return (typeof value === 'string' && value.trim().length > 0) ||
      (Number.isSafeInteger(value) && value > 0);
  }

  function result(error) {
    return {
      projected: true,
      currency: 'USD',
      eligibleSubtotal: 0,
      excludedSubtotal: 0,
      highestTier: null,
      nextTier: null,
      remaining: null,
      progress: 0,
      error: error
    };
  }

  function project(input) {
    if (!input || typeof input !== 'object') return result('invalid_input');
    if (input.currency !== 'USD') return result('unsupported_currency');
    if (!Array.isArray(input.tiers) || !input.tiers.length) return result('invalid_tiers');
    var tiers = [];
    for (var t = 0; t < input.tiers.length; t += 1) {
      var tier = input.tiers[t];
      if (!tier || !identifier(tier.id) || !Number.isSafeInteger(tier.threshold) || tier.threshold <= 0 ||
          tiers.some(function (known) { return String(known.id) === String(tier.id) || known.threshold === tier.threshold; })) {
        return result('invalid_tiers');
      }
      tiers.push({ id: tier.id, threshold: tier.threshold });
    }
    tiers.sort(function (a, b) { return a.threshold - b.threshold; });
    if (!Array.isArray(input.products) || !Array.isArray(input.lines)) return result('invalid_input');
    var products = new Map();
    for (var p = 0; p < input.products.length; p += 1) {
      var product = input.products[p];
      if (!product || !identifier(product.id) || products.has(String(product.id))) return result('invalid_products');
      products.set(String(product.id), product);
    }
    var output = result(null);
    for (var l = 0; l < input.lines.length; l += 1) {
      var line = input.lines[l];
      if (!line || !identifier(line.productId) || !Number.isSafeInteger(line.quantity) || line.quantity <= 0 ||
          !Number.isSafeInteger(line.price) || line.price < 0) return result('invalid_lines');
      var selected = products.get(String(line.productId));
      if (!selected) return result('unknown_product');
      var amount = line.price * line.quantity;
      if (!Number.isSafeInteger(amount)) return result('unsafe_total');
      if (selected.giftEligible === true) output.eligibleSubtotal += amount;
      else output.excludedSubtotal += amount;
      if (!Number.isSafeInteger(output.eligibleSubtotal) || !Number.isSafeInteger(output.excludedSubtotal) ||
          !Number.isSafeInteger(output.eligibleSubtotal + output.excludedSubtotal)) return result('unsafe_total');
    }
    for (var i = 0; i < tiers.length; i += 1) {
      if (output.eligibleSubtotal >= tiers[i].threshold) output.highestTier = tiers[i];
      else {
        output.nextTier = tiers[i];
        break;
      }
    }
    output.remaining = output.nextTier ? output.nextTier.threshold - output.eligibleSubtotal : 0;
    output.progress = output.nextTier ? Math.min(1, output.eligibleSubtotal / output.nextTier.threshold) : 1;
    return output;
  }

  return { project: project };
}));
